export default __webpack_public_path__ + "static/media/enter.535cd3d1.wav";